module.exports = __webpack_public_path__ + "resources/img/img-vormetric-encryption-m-en.c17ee1122224d2f185b3474df65e8690.png";